import { format } from 'date-fns';

import {
  ILoyaltyQuestProgress,
  ILoyaltyQuestUi,
  LoyaltyQuestPrizeType,
  LoyaltyQuestStatus,
} from '@fhs-legacy/frontend/src/generated/graphql-gateway';

import { ChallengeHomeCardProps } from '../components';

export function getChallengeButtonText(status: LoyaltyQuestStatus) {
  switch (status) {
    case LoyaltyQuestStatus.NOT_ENROLLED:
      return 'Start Challenge';
    case LoyaltyQuestStatus.COMPLETED:
      return undefined;
    default:
      return 'Order Now';
  }
}

function formatDateAsLocal(dateString: string) {
  try {
    const [year, month, day] = dateString.split('T')[0].split('-').map(Number);

    const date = new Date(year, month - 1, day);

    return format(date, 'MMMM do');
  } catch (error) {
    // Fallback
    return format(new Date(), 'MMMM do');
  }
}

export function getChallengeDescription(challenge: ILoyaltyQuestUi) {
  if (challenge.status === LoyaltyQuestStatus.COMPLETED) {
    if (challenge.prize?.type === LoyaltyQuestPrizeType.BONUS_POINTS) {
      const extraStepsPoints =
        challenge?.stepDetails?.reduce((acc, step) => acc + (step.pointValue ?? 0), 0) ?? 0;
      return `${
        (challenge.prize?.points ?? 0) + extraStepsPoints
      } points were applied to your account 🎉`;
    }
    return 'Your prize is ready to be redeemed 🎉';
  }

  return `From ${formatDateAsLocal(challenge.startDate)} to ${formatDateAsLocal(
    challenge.endDate
  )}`;
}

export function getChallengeBadge(status: LoyaltyQuestStatus, _?: ILoyaltyQuestProgress | null) {
  switch (status) {
    case LoyaltyQuestStatus.NOT_ENROLLED:
      return undefined;

    case LoyaltyQuestStatus.COMPLETED:
      return 'Challenge Completed';

    default:
      return 'Challenge Started';
  }
}

function getImageWidth(hasMoreThanOneChallenge: boolean, isDesktop: boolean, deviceWidth: number) {
  const padding = 16;
  const availableWidth = deviceWidth - 2 * padding;
  if (!isDesktop) {
    return hasMoreThanOneChallenge ? availableWidth - 0.25 * availableWidth : availableWidth;
  }
  return availableWidth;
}

export function createChallengeHomeCardProps(
  challengesData: ILoyaltyQuestUi[],
  isDesktop: boolean,
  deviceWidth: number,
  showChallengeInfo: (challengeId: string) => void
): ChallengeHomeCardProps | undefined {
  if (challengesData.length === 0) {
    return undefined;
  }

  const hasMoreThanOneChallenge = challengesData.length > 1;

  const challengeHomeCardProps: ChallengeHomeCardProps['challenges'] = challengesData.map(
    challenge => {
      return {
        id: challenge.id,
        image: isDesktop ? challenge.desktopImage : challenge.mobileImage,
        accessibilityLabel: challenge.name?.trim() || 'Challenge',
        imageWidth: getImageWidth(hasMoreThanOneChallenge, isDesktop, deviceWidth),
        onPress: () => showChallengeInfo(challenge.id),
      };
    }
  );

  return {
    challenges: challengeHomeCardProps,
  };
}
